module.exports = {
    digitalStageTrackingOptions: [
        "-None-",
        "Pending Up-Selling/Cross-Selling",
        "L - Qualification",
        "L - Needs Analysis",
        "L - Value Proposition",
        "L - Identify Decision Makers",
        "L - Presentation",
        "L - Application",
        "L - Signature",
        "L - Underwriting",
        "L - Medical",
        "L - APS/MIB",
        "L - Decision ( Approved/Denial/PostPone/Rated)",
        "L - Accepted/Re-Apply/Change Premium",
        "L - Delivery",
        "In - Presentation",
        "In - Application",
        "In - Documents Pending(Sin Number/Void Chq,/Etc.)",
        "In - Signature",
        "T - Lead stage in Leads- Let's Go Ahead and do the policy",
        "T - Info shared (Travelers)",
        "T - Credit Card info(Pending/Provided)",
        "T - Wait till the specific Date",
        "T - Policy Done",
      ],
      statusOptions:[
        "-None-",
        "Active",
        "Inactive",
        "Attempted to Contact",
        "Contact in Future",
        "Pre Qualified",
        "Discovery Call",
        "Contacted",
        "Not Interested",
        "Discussions",
        "Quoted",
        "Appointment",
        "Application Go Ahead Received - Life",
        "Application Go Ahead Received - Travel / Supervisa",
      ],
      insuranceleadSourceOptions:[
        "-None-",
        "Radio",
        "Trade Show",
        "Vendor Partner Seminar",
        "Referral",
        "Internal Seminar",
        "Google",
        "Social Media",
        "Cold Call",
        "Email Campaign",
        "Website",
        "Facebook",
        "Twitter",
        "Canadian LIC Website",
        "Harpreet Puri Website",
        "Linked In",
        "SVIC Website (Super Visa)",
        "Walk Ins",
        "Old Database",
        "Google AdWords",
      ],
      advisorModuleNameOptions:[
        "-None-",
        "Jonny Advisor",
        "test",
        "Jonny Saini",
        "fghjns",
        "test2345",
        "Preeti hooda",
        "Cheshta Sharma",
      ],
      socialMediaInformationOptions:["Select", "-None-", "Yes", "No"],

      parentClientOptions:[
        "-None-",
  
        "Shashi Nidhi",
        "Shashi saini",
        "test test",
        "test test",
        "Preeti Hooda",
        "Christopher Maclead (Sample)",
        "Kris Marrier (Sample)",
      ],
      preferredContactMethodOptions:[
        "Email Cell Phone Home Phone",
        "Email",
        "Cell Phone",
        "Home Phone",
        "Work Phone",
        "Text",
        "Email, Cell Phone, WhatsApp",
      ],
      availabilityOptions:[
        "Weekdays - Morning",
        "Weekdays - Afternoon",
        "Weekdays - Evening",
        "Weekends - Morning",
        "Weekends - Afternoon",
        "Weekends - Evening",
        "Weekdays - Morning, Afternoon, Evening",
        "Weekends - Morning, Afternoon, Evening",
        "Weekdays - Weekends - Morning",
        "Weekdays - Weekends - Afternoon",
        "Weekdays - Weekends - Evening",
      ],
    genderOptions:["-None-", "Male", "Female", "Unkown"],
    choice:["-None-", "Unknown", "Yes", "No"],
    priorityOptions:[
        "-None-",
        "Unknown",
        "Low",
        "Moderate",
        "High",
        "Expert",
      ],
      optionsArray: ["available", "unavailable", "none"],
      serviceAvailedOptions:[
        "Life Insurance",
        "Living Benefits",
        "Health & Dental Insurance",
        "Travel Insurance",
        "Investments",
        "Combination or Hybrid Insurance",
        "Loan Protection",
        "Group Insurance",
        "Business Insurance",
      ],
      lifeInsuranceOptions:[
        "Term Life",
        "Universal Life",
        "Permanent Universal Life",
        "Whole Life",
        "Participating Whole Life",
        "Non Medical",
        "Permanent / T100",
      ],
      groupInsuranceOption:[
        "Group Life",
        "Group Disability",
        "Group Accidental Benefits",
        "Group Health and Dental",
      ],
      lifeBenefitsOptions:[
        "Critical Illness Disability - Accidental",
        "Disability - Accidental",
        "Disability - Illness",
        "Hospital Expenses",
        "Accidental Benefits",
        "Critical Illness",
      ],
      loanProtectionOptions:[
        "Living Benefits- Critical, Disability",
        "Travel Insurance- SuperVisa, Visitor, Travel",
        "Investments- RESP, RRSP, TFSA",
        "Health & Dental Insurance",
        ],
        travelInsuranceOptions:[
            "Travel",
            "Super Visa",
            "Visitor",
            "International Student",
          ],
          investmentOptions:[
            // " Business Insurance Mutual Funds TFSA Seg Funds Annuities RRSP RESP GIC Savings Account Pension Plan RIF GIABusiness Insu",
            "Business Insurance",
            "Mutual Funds",
            "TFSA",
            "Seg Funds",
            "Annuities",
            "RRSP",
            "RESP",
            "GIC",
            "Savings Account",
            "Pension Plan",
            "RIF",
            "GIA",
          ],
          processStageOptions:[
            "Attempted to Contact",
            "Discussions",
            "Quoted",
            "Appointment",
            "Contact in Future",
            "Application Go Ahead Received - Life",
            "Application Go Ahead Received - Travel / Supervisa",
            "Application Go Ahead - RESP, RRSP, TFSA, SEG",
          ],
          relationShipStatusOptions:[
            "-None-",
            "Single",
            "Married",
            "Divorced",
            "Common Law",
            "Widow",
            "Widower",
          ],
          religionOptions:[
            "-None-",
            "Buddhism",
            "Unknow",
            "Christianity",
            "Hinduism",
            "Islam",
            "Judaism",
            "Sikhism",
          ],
          celebratedFestivalsOptions:[
            "Canada Day",
            "New Year",
            "Family Day",
            "Victoria Day",
            "Father's Day",
            "Mother's Day",
          ],
          festivals:[
            "Eid-ul-Fitr",
            "Bakr-Eid",
            "Holi",
            "Dussehra",
            "Diwali",
            "Raksha Bandhan",
            "Guru Nanak Jayanti",
            "Guru Gobind Singh Jayanti",
            "Guru Granth Sahib Prakash Divas",
            "Passover",
            "Victoria Day",
            "Family Day",
            "Mother's Day",
            "Thanksgiving",
            "Christmas",
            "New Year",
            "Lohri",
            "Vaisakhi",
            "Father's Day",
          ],
          referredByOtions:[
            " -None-",
            "Social Media",
            "Radio",
            "Google",
            "Advisor",
            "External Referral ",
          ],
          citizenshipStatusOptions:[
            "-None-",
            "Canadian Citizenship",
            "PR",
            "Work Permit",
            "Student ",
          ],
          

  
    
    
    
  
     
}